import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import DateSelection from './components/DateSelection';
import {
  setEndDate,
  setStartDate,
  setProperty,
  setNumberOfGuests,
  setQueryInput,
  setAccountNumber,
  setAccountPin,
  submitRewardsAccount,
  setSelectedOffers,
  setIsAdmin,
  setActiveBlock,
  setAdminSelectedOffers,
  setHotelOverrideCodes,
  onStartDateChange,
  onEndDateChange,
  setMaxStayExceeded
} from 'routes/DateSelection/reducer';
import { roomTypeSelector } from 'routes/ChooseAccommodation/selectors';
import {
  endDateSelector,
  propertySelector,
  startDateSelector,
  numberOfGuestsSelector,
  queryInputSelector,
  accountNumberSelector,
  accountPinSelector,
  blockCodeSelector,
  submittedAccountSelector,
  isAdminSelector,
  submittedBlockCodeSelector,
  activeBlockSelector,
  secondAccountNumberSelector,
  secondSubmittedAccountSelector,
  isWaitListBookingSelector,
  waitListBookingReasonSelector,
  waitListBookingCommentSelector,
  adminSelectedOffersSelector,
  hotelOverrideCodesSelector,
  maxStayExceededSelector
} from 'routes/DateSelection/selectors';
import {
  setToken,
  setBookingSource,
  setGuestProfiles,
  setInMobileApp
} from 'routes/reducer';
import {
  tokenSelector,
  bookingSourceSelector,
  inMobileAppSelector
} from 'routes/selectors';

const mapStateToProps = createStructuredSelector({
  startDate: startDateSelector,
  endDate: endDateSelector,
  property: propertySelector,
  roomType: roomTypeSelector,
  numberOfGuests: numberOfGuestsSelector,
  queryInput: queryInputSelector,
  accountNumber: accountNumberSelector,
  accountPin: accountPinSelector,
  submittedAccount: submittedAccountSelector,
  blockCode: blockCodeSelector,
  submittedBlockCode: submittedBlockCodeSelector,
  activeBlock: activeBlockSelector,
  isAdmin: isAdminSelector,
  token: tokenSelector,
  bookingSource: bookingSourceSelector,
  secondAccountNumber: secondAccountNumberSelector,
  secondSubmittedAccount: secondSubmittedAccountSelector,
  isWaitListBooking: isWaitListBookingSelector,
  waitListBookingReason: waitListBookingReasonSelector,
  waitListBookingComment: waitListBookingCommentSelector,
  adminSelectedOffers: adminSelectedOffersSelector,
  hotelOverrideCodes: hotelOverrideCodesSelector,
  maxStayExceeded: maxStayExceededSelector,
  inMobileApp: inMobileAppSelector
});

function mapDispatchToProps(dispatch) {
  return {
    setStartDate: date => dispatch(setStartDate(date)),
    setEndDate: date => dispatch(setEndDate(date)),
    setProperty: property => dispatch(setProperty(property)),
    setNumberOfGuests: numberOfGuests =>
      dispatch(setNumberOfGuests(numberOfGuests)),
    setQueryInput: currentMonthStart =>
      dispatch(setQueryInput(currentMonthStart)),
    setAccountNumber: accountNumber =>
      dispatch(setAccountNumber(accountNumber)),
    setAccountPin: accountPin => dispatch(setAccountPin(accountPin)),
    submitRewardsAccount: () => dispatch(submitRewardsAccount()),
    setActiveBlock: block => dispatch(setActiveBlock(block)),
    setSelectedOffers: offers => dispatch(setSelectedOffers(offers)),
    setIsAdmin: isAdmin => dispatch(setIsAdmin(isAdmin)),
    setToken: token => dispatch(setToken(token)),
    setBookingSource: bookingSource =>
      dispatch(setBookingSource(bookingSource)),
    setGuestProfiles: profiles => dispatch(setGuestProfiles(profiles)),
    setAdminSelectedOffers: adminSelectedOffers =>
      dispatch(setAdminSelectedOffers(adminSelectedOffers)),
    onStartDateChange: date => dispatch(onStartDateChange(date)),
    onEndDateChange: date => dispatch(onEndDateChange(date)),
    setHotelOverrideCodes: hotelOverrideCodes =>
      dispatch(setHotelOverrideCodes(hotelOverrideCodes)),
    setMaxStayExceeded: maxStayExceeded =>
      dispatch(setMaxStayExceeded(maxStayExceeded)),
    setInMobileApp: inMobileApp => dispatch(setInMobileApp(inMobileApp))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateSelection);
